import type {
  OrganizationTreeNode,
  Organization,
} from 'src/context/MyScheduleContext/types'

/**
 * Convert OrganizationTreeNode to Organization type (for state compatibility)
 */
export function treeNodeToOrganization(
  node: OrganizationTreeNode
): Organization {
  return {
    id: node.id,
    name: node.name,
    name_full: node.name_full,
    abbreviation: node.abbreviation,
    image: node.image_url,
  }
}

/**
 * TreeSelect data node structure
 */
export interface TreeSelectNode {
  value: string
  title: string
  label: string
  data?: OrganizationTreeNode
  children?: TreeSelectNode[]
  isLeaf?: boolean
}

/**
 * Transform OrganizationTreeNode[] to TreeSelect treeData format
 */
export function transformToTreeSelectData(
  nodes: OrganizationTreeNode[]
): TreeSelectNode[] {
  return nodes.map((node) => ({
    value: node.id,
    title: node.name_full || node.name,
    label: node.name_full || node.name,
    data: node,
    children: node.children?.length
      ? transformToTreeSelectData(node.children)
      : undefined,
    isLeaf: node.children_count === 0,
  }))
}

/**
 * Find a node by ID in the tree (recursive)
 */
export function findNodeById(
  nodes: OrganizationTreeNode[],
  id: string
): OrganizationTreeNode | null {
  for (const node of nodes) {
    if (node.id === id) {
      return node
    }
    if (node.children?.length) {
      const found = findNodeById(node.children, id)
      if (found) {
        return found
      }
    }
  }
  return null
}

/**
 * Get all first-level node IDs for default expansion
 */
export function getFirstLevelKeys(nodes: OrganizationTreeNode[]): string[] {
  return nodes.map((node) => node.id)
}
